/*SYSTEM IMPORTS*/
import React, { memo } from "react"

/*VIEWS*/
import DoctorHeader from 'components/ui/Header'
import DoctorFooter from 'components/ui/Footer'


const MainLayout = memo( ({ params, children = null}) => {
    const {menu, ...options} = params

    return (
        <>
            <DoctorHeader
                menu={menu}
                {...options}
            />
            { children }
            <DoctorFooter {...options}/>
        </>
    )
} )

export default MainLayout
